<template>
  <div class="findHospital">
    <div class="searchHospital">
      <div class="searchHospitalTitle">
        <van-field class="searchHospitalVanField" ref="inputs" left-icon="search" clearable placeholder="请输入要搜索的医院" v-model="value" />
        <span class="searchHospitaCancel" @click="searchGoods">取消</span>
      </div>
      <div class="hospitalList" v-if="LocationFail">
        <ul>
          <li>例：中国人民解放军总医院（301）</li>
        </ul>
      </div>
      <div class="hospitalList" v-else>
        <ul>
          <li v-for="item in hospitalList" :key="item.id" @click="onChoose(item)">
            <img src="../../assets/search.png" alt />
            {{item.name}}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import Storage from '@/tools/storage'
import { institutionNameSearch, institutionListLocation } from '@/api/check'
export default {
  name: 'searchHospital',
  props: ['LocationFail'],
  // Storage.set('Location'
  data() {
    return {
      value: '',
      hospitalList: [],
      flag: false
    }
  },
  watch: {
    value(newName, oldName) {
      this.LocationFail = false
      let params = { search: newName }
      this.getInstitutionNameSearch(params)
    }
  },
  methods: {
    async getInstitutionNameSearch(params) {
      if (params.search == '') {
        this.hospitalList = JSON.parse(Storage.get('hospitalListData'))
        // this.getInstitutionListLocation()
      } else {
        let res = await institutionNameSearch(params)
        if (res) {
          this.hospitalList = [...res]
        }
      }
    },
    async getInstitutionListLocation() {
      let params = JSON.parse(Storage.get('Location'))
      let res = await institutionListLocation(params)
      if (res) {
        this.hospitalList = [...res]
        Storage.set('hospitalListData', res)
      }
    },
    onChoose(e) {
      // Storage.set('value', e.name)
      this.$router.push({
        path: '/filmQuery',
        query: {
          value: e.name,
          id: e.id,
          search: e.search,
          placeholder: e.condition,
          is_bar_code: e.is_bar_code,
          institution_condition: e.institution_condition
        }
      })
    },
    searchGoods() {
      this.$router.push({ path: '/filmQuery' })
    },
    changfouce() {
      this.$nextTick(x => {
        //正确写法
        this.$refs.inputs.focus()
      })
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.inputs.focus()
    })
  },
  created() {
    // this.changfouce();
    this.getInstitutionListLocation()
  }
}
</script>
<style lang="scss" scoped>
@import '../../style/findHospital/index.css';
</style>
